module.exports = __webpack_public_path__ + "img/03.01654c93.jpg";